<template>
  <div class="Axe">
    <div class="Axe__delete">
      <button class="button" :disabled="index === 0" @click="$emit('up')">
        <i class="icon fa fa-arrow-up"></i>
      </button>
      <button class="is-small is-danger button" @click="$emit('delete')">
        <i class="fa fa-times"></i>
      </button>
      <button
        class="button"
        :disabled="index === total - 1"
        @click="$emit('down')"
      >
        <i class="icon fa fa-arrow-down"></i>
      </button>
    </div>
    <div class="squarebox">
      <div class="columns is-multiline">
        <div class="column is-full">
          <horiz-field>
            <label for="" class="label" slot="label">Axe :</label>
            <kv-suggestor
              :inline="true"
              :color="'is-info'"
              :type="'axes'"
              :item="axe.axe_id"
              @update="updateKey('axe_id', $event)"
            ></kv-suggestor>
          </horiz-field>
        </div>
        <div class="column is-full">
          <div class="Axe__pictures">
            <div v-show="axe.pictures.length === 0">
              Pas encore d'images, ajoutez-en une !
            </div>
            <axe-edit-picture
              v-for="(pic, index) in axe.pictures"
              :picture="pic"
              :key="`${index}-${pic.picture_id}`"
              :index="index"
              :total="axe.pictures.length"
              @down="movePic(index, 1)"
              @up="movePic(index, -1)"
              @delete="removePic(index)"
              @update="updatePictureBlock(index, $event)"
            />
            <div class="buttons">
              <button class="button" @click="addPicture">
                Ajouter une photo
              </button>
            </div>
          </div>
        </div>
        <div class="column is-full">
          <vertical-field>
            <label for="" class="label" slot="label"
              >Texte
              <span :class="axe.text.length > 300 ? 'has-text-danger' : ''"
                >({{ axe.text.length }} / 300 caractères)</span
              >
              :</label
            >
            <!-- eslint-disable vue/no-textarea-mustache -->
            <textarea
              class="textarea is-small "
              cols="30"
              rows="5"
              @input="updateKey('text', $event.target.value)"
              >{{ axe.text }}</textarea
            >
            <!-- eslint-enable -->
          </vertical-field>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import HorizField from "../../../components/Form/HorizField";
import KvSuggestor from "../../../components/Form/KvSuggestor";
import VerticalField from "../../../components/Form/VerticalField";
import { cheapoClone } from "../../../util/func";
import { PictureForContentBlock } from "../../../store/models/project";
import AxeEditPicture from "./AxeEditPicture";

export default {
  name: "project-edit-axe-one",
  components: { AxeEditPicture, HorizField, KvSuggestor, VerticalField },
  props: {
    axe: {},
    index: {},
    total: {}
  },
  methods: {
    updateKey(key, val) {
      const c = cheapoClone(this.axe);
      c[key] = val;
      this.$emit("update", c);
    },
    updatePictureBlock(index, $event) {
      const c = cheapoClone(this.axe);
      c.pictures[index] = $event;
      this.$emit("update", c);
    },
    movePic(index, d) {
      const c = cheapoClone(this.axe);
      c.pictures.splice(index + d, 0, c.pictures.splice(index, 1)[0]);
      this.$emit("update", c);
    },
    addPicture() {
      const c = cheapoClone(this.axe);
      c.pictures.push(PictureForContentBlock());
      this.$emit("update", c);
    },
    removePic(index) {
      const c = cheapoClone(this.axe);
      c.pictures = c.pictures.filter((a, i) => i !== index);
      this.$emit("update", c);
    }
  }
};
</script>
